module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/gi-product-1-4db5690bd8209c1e2d5786e818929c07.jpg";